import { render, staticRenderFns } from "./start-page-input.vue?vue&type=template&id=747f4c54&"
import script from "./start-page-input.vue?vue&type=script&lang=js&"
export * from "./start-page-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports